var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":_vm.$t('instructions.title'),"data-cy":"instructionTitle"},model:{value:(_vm.value.title),callback:function ($$v) {_vm.$set(_vm.value, "title", $$v)},expression:"value.title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }